import face1 from "../../asserts/images/faces/Dhina.png";
import face2 from "../../asserts/images/faces/karthi2.jpeg";
import face3 from "../../asserts/images/faces/vishal.jpeg";
import "./faces.scss";

const Faces = () => {
  return (
    <div className="faces-box">
      <h1>The Faces Behind the Mission</h1>
      <p>
        Meet the passionate individuals committed to making a difference and
        driving positive change in our communities.
      </p>
      <div className="row face-images">
        <div className="col-lg-4 col-md-6 col-sm-12 col-12 ">
          <div className="image-box">
            <div className="role">
              <h3>Dhinaharan K</h3>
              <p>Managing Trustee</p>
            </div>
            <img src={face1} alt="" />
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
          <div className="image-box">
            <div className="role">
              <h3>Karthik K</h3>
              <p>Financial Trustee</p>
            </div>
            <img src={face2} alt="" />
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
          <div className="image-box">
            <div className="role">
              <h3>Vishal V</h3>
              <p>Member Trustee</p>
            </div>
            <img src={face3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Faces;
